import React from "react";
import bgVideo from "../../../Assets/Background.mp4";
import QuoteBox from "./QuoteBox";  // new component
import "./Home.css";

const Home = ({ isLoaded }) => {
  return (
    <header className="hero">
      <div className="video-wrapper">
        <video autoPlay loop muted playsInline>
          <source src={bgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="overlay-content">
        {/* Left side banner (agar rakhna ho to) */}
        <div className={`banner ${isLoaded ? "animate" : ""}`}>
          <h1>UMA Design &amp; Construction</h1>
          <p>Shape your Future with Careful Planning</p>
        </div>

        {/* Right side Quote Box */}
        <QuoteBox />
      </div>
    </header>
  );
};

export default Home;
